import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.svg";
import cashlet from '../../assets/cashlet.svg';
import "./footer.css"
export default function Footer() {
  return (
    <>
      {/* {location.pathname !== "/ios-coming-soon" ? <NewsLetter /> : null} */}
      <footer className="relative pt-8 mb-6 footer-bg font-site">
        <div className="lg:container mx-auto px-5 md:px-8 py-3">
          <div className="hidden-sm">
            <div className="flex items-start justify-between pb-2 space-y-4">
              <div className="space-y-6">
                <div className="inline-flex items-center space-x-4">
                  <img src={logo} className="w-8 md:w-10" alt="logo" />
                  <img className="w-auto" src={cashlet} alt="cashlet" />
                </div>
                <ul
                  className="text-sm lg:text-lg opacity-70 text-black"
                  style={{ lineHeight: "26px" }}
                >
                  <li>4th Floor, Laiboni Center</li>
                  <li>Lenana Road, Kilimani</li>
                  <li>Nairobi, Kenya </li>
                  <li>0112029738 </li>
                  <li className="pt-4 underline">team@cashlet.co.ke</li>
                </ul>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <a
                    href="https://web.facebook.com/cashletapp/"
                    className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                    type="button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_830)">
                        <path
                          d="M12 2.61914C6.477 2.61914 2 7.09614 2 12.6191C2 17.6101 5.657 21.7471 10.438 22.4981V15.5091H7.898V12.6191H10.438V10.4161C10.438 7.91014 11.93 6.52614 14.215 6.52614C15.309 6.52614 16.453 6.72114 16.453 6.72114V9.18114H15.193C13.95 9.18114 13.563 9.95214 13.563 10.7431V12.6191H16.336L15.893 15.5091H13.563V22.4981C18.343 21.7481 22 17.6091 22 12.6191C22 7.09614 17.523 2.61914 12 2.61914Z"
                          fill="#17191E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_830">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0 0.619141)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <a
                    href="https://www.instagram.com/cashletapp/"
                    className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                    type="button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_833)">
                        <path
                          d="M12 2.61914C14.717 2.61914 15.056 2.62914 16.122 2.67914C17.187 2.72914 17.912 2.89614 18.55 3.14414C19.21 3.39814 19.766 3.74214 20.322 4.29714C20.8305 4.79704 21.224 5.40173 21.475 6.06914C21.722 6.70614 21.89 7.43214 21.94 8.49714C21.987 9.56314 22 9.90214 22 12.6191C22 15.3361 21.99 15.6751 21.94 16.7411C21.89 17.8061 21.722 18.5311 21.475 19.1691C21.2247 19.8369 20.8311 20.4418 20.322 20.9411C19.822 21.4495 19.2173 21.8429 18.55 22.0941C17.913 22.3411 17.187 22.5091 16.122 22.5591C15.056 22.6061 14.717 22.6191 12 22.6191C9.283 22.6191 8.944 22.6091 7.878 22.5591C6.813 22.5091 6.088 22.3411 5.45 22.0941C4.78233 21.8436 4.17753 21.4501 3.678 20.9411C3.16941 20.4413 2.77593 19.8366 2.525 19.1691C2.277 18.5321 2.11 17.8061 2.06 16.7411C2.013 15.6751 2 15.3361 2 12.6191C2 9.90214 2.01 9.56314 2.06 8.49714C2.11 7.43114 2.277 6.70714 2.525 6.06914C2.77524 5.40132 3.1688 4.79646 3.678 4.29714C4.17767 3.78837 4.78243 3.39487 5.45 3.14414C6.088 2.89614 6.812 2.72914 7.878 2.67914C8.944 2.63214 9.283 2.61914 12 2.61914ZM12 7.61914C10.6739 7.61914 9.40215 8.14592 8.46447 9.08361C7.52678 10.0213 7 11.2931 7 12.6191C7 13.9452 7.52678 15.217 8.46447 16.1547C9.40215 17.0924 10.6739 17.6191 12 17.6191C13.3261 17.6191 14.5979 17.0924 15.5355 16.1547C16.4732 15.217 17 13.9452 17 12.6191C17 11.2931 16.4732 10.0213 15.5355 9.08361C14.5979 8.14592 13.3261 7.61914 12 7.61914ZM18.5 7.36914C18.5 7.03762 18.3683 6.71968 18.1339 6.48526C17.8995 6.25084 17.5815 6.11914 17.25 6.11914C16.9185 6.11914 16.6005 6.25084 16.3661 6.48526C16.1317 6.71968 16 7.03762 16 7.36914C16 7.70066 16.1317 8.0186 16.3661 8.25302C16.6005 8.48744 16.9185 8.61914 17.25 8.61914C17.5815 8.61914 17.8995 8.48744 18.1339 8.25302C18.3683 8.0186 18.5 7.70066 18.5 7.36914ZM12 9.61914C12.7956 9.61914 13.5587 9.93521 14.1213 10.4978C14.6839 11.0604 15 11.8235 15 12.6191C15 13.4148 14.6839 14.1779 14.1213 14.7405C13.5587 15.3031 12.7956 15.6191 12 15.6191C11.2044 15.6191 10.4413 15.3031 9.87868 14.7405C9.31607 14.1779 9 13.4148 9 12.6191C9 11.8235 9.31607 11.0604 9.87868 10.4978C10.4413 9.93521 11.2044 9.61914 12 9.61914Z"
                          fill="#17191E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_833">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0 0.619141)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCX_gBYtp_3X--RL0TvQ0olg"
                    className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                    type="button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_836)">
                        <path
                          d="M8.75439 12.493L12.0073 10.6196L8.75439 8.74609V12.493Z"
                          fill="black"
                        />
                        <path
                          d="M10 0.619141C4.478 0.619141 0 5.09714 0 10.6191C0 16.1411 4.478 20.6191 10 20.6191C15.522 20.6191 20 16.1411 20 10.6191C20 5.09714 15.522 0.619141 10 0.619141ZM16.2485 10.6294C16.2485 10.6294 16.2485 12.6574 15.9912 13.6353C15.847 14.1706 15.425 14.5927 14.8897 14.7367C13.9117 14.9941 10 14.9941 10 14.9941C10 14.9941 6.09848 14.9941 5.11032 14.7265C4.57504 14.5825 4.15298 14.1602 4.00879 13.625C3.75137 12.6574 3.75137 10.6191 3.75137 10.6191C3.75137 10.6191 3.75137 8.59125 4.00879 7.61331C4.15283 7.07803 4.58527 6.6456 5.11032 6.50156C6.08826 6.24414 10 6.24414 10 6.24414C10 6.24414 13.9117 6.24414 14.8897 6.51178C15.425 6.65582 15.847 7.07803 15.9912 7.61331C16.2589 8.59125 16.2485 10.6294 16.2485 10.6294Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_836">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(0 0.619141)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <a
                    href="https://twitter.com/cashletapp"
                    className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                    type="button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_839)">
                        <path
                          d="M10.0009 20.619C15.5237 20.619 20.0008 16.1419 20.0008 10.6191C20.0008 5.09625 15.5237 0.619141 10.0009 0.619141C4.47809 0.619141 0.000976562 5.09625 0.000976562 10.6191C0.000976562 16.1419 4.47809 20.619 10.0009 20.619Z"
                          fill="black"
                        />
                        <path
                          d="M16.1257 7.80546C15.6971 7.99548 15.2362 8.124 14.7527 8.1814C15.2463 7.88567 15.6251 7.41774 15.8039 6.85926C15.3421 7.13325 14.8303 7.332 14.2861 7.43914C13.85 6.97477 13.2288 6.68457 12.5409 6.68457C11.2211 6.68457 10.1507 7.75501 10.1507 9.07483C10.1507 9.26218 10.1719 9.44454 10.2129 9.61959C8.22636 9.51994 6.46499 8.5684 5.28599 7.12184C5.08028 7.47479 4.96228 7.88567 4.96228 8.32365C4.96228 9.15273 5.38457 9.88466 6.02558 10.3132C5.63395 10.3009 5.26514 10.1934 4.94302 10.0139C4.94285 10.0241 4.94285 10.0342 4.94285 10.0442C4.94285 11.2023 5.76711 12.1683 6.86037 12.3878C6.66 12.4427 6.44841 12.4717 6.23076 12.4717C6.07639 12.4717 5.92683 12.4569 5.78101 12.4291C6.08512 13.3785 6.96768 14.0696 8.01387 14.089C7.19567 14.7302 6.16516 15.1122 5.04499 15.1122C4.85247 15.1122 4.66173 15.101 4.4751 15.0787C5.53235 15.7572 6.78906 16.1527 8.13883 16.1527C12.5354 16.1527 14.9397 12.5106 14.9397 9.35167C14.9397 9.2481 14.9374 9.14489 14.9328 9.04257C15.4002 8.70566 15.8053 8.28479 16.1257 7.80546Z"
                          fill="#F1F2F2"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_839">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(0 0.619141)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <a
                    href="https://www.tiktok.com/@cashletapp"
                    className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                    type="button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M12 2.09375C10.0222 2.09375 8.08879 2.68024 6.4443 3.77905C4.79981 4.87787 3.51809 6.43965 2.76121 8.26692C2.00433 10.0942 1.8063 12.1048 2.19215 14.0447C2.578 15.9845 3.53041 17.7663 4.92894 19.1648C6.32746 20.5633 8.10929 21.5158 10.0491 21.9016C11.9889 22.2875 13.9996 22.0894 15.8268 21.3325C17.6541 20.5757 19.2159 19.2939 20.3147 17.6495C21.4135 16.005 22 14.0716 22 12.0938C21.9974 9.4424 20.9429 6.9004 19.0681 5.02561C17.1934 3.15082 14.6514 2.0964 12 2.09375ZM17.939 9.80675V10.4528C17.939 10.5022 17.9291 10.5511 17.9099 10.5967C17.8907 10.6422 17.8625 10.6835 17.8271 10.718C17.7917 10.7525 17.7497 10.7795 17.7037 10.7975C17.6576 10.8155 17.6084 10.8241 17.559 10.8228C16.5032 10.7482 15.493 10.3626 14.656 9.71475V14.4427C14.6558 14.966 14.5513 15.484 14.3487 15.9665C14.1461 16.4489 13.8494 16.8862 13.476 17.2528C13.0995 17.6289 12.6517 17.9261 12.1589 18.127C11.6661 18.3279 11.1382 18.4285 10.606 18.4228C9.53587 18.4212 8.50876 18.0013 7.744 17.2528C7.2574 16.7622 6.9069 16.1533 6.727 15.4862C6.5471 14.819 6.544 14.1165 6.718 13.4478C6.877 12.8057 7.198 12.2157 7.651 11.7347C7.98883 11.3218 8.41468 10.9896 8.8974 10.7625C9.38012 10.5353 9.90751 10.4189 10.441 10.4218H11.261V12.1248C11.2614 12.1742 11.2512 12.2232 11.2311 12.2684C11.2111 12.3136 11.1816 12.354 11.1447 12.387C11.1078 12.4199 11.0643 12.4446 11.0171 12.4594C10.9699 12.4742 10.9201 12.4787 10.871 12.4727C10.3949 12.3297 9.88186 12.3772 9.44004 12.6051C8.99822 12.8329 8.66214 13.2235 8.50265 13.6943C8.34315 14.1651 8.37269 14.6795 8.58505 15.129C8.79742 15.5785 9.176 15.928 9.641 16.1038C9.911 16.2587 10.213 16.3498 10.523 16.3708C10.763 16.3808 11.003 16.3507 11.231 16.2787C11.6116 16.1503 11.9427 15.9064 12.1781 15.5808C12.4134 15.2553 12.5414 14.8644 12.544 14.4628V5.84775C12.544 5.75245 12.5818 5.66103 12.6491 5.59354C12.7164 5.52606 12.8077 5.48801 12.903 5.48775H14.318C14.4099 5.48786 14.4984 5.52315 14.5651 5.58637C14.6319 5.64959 14.6719 5.73595 14.677 5.82775C14.7286 6.26898 14.8687 6.69525 15.089 7.08102C15.3093 7.46678 15.6052 7.8041 15.959 8.07275C16.4371 8.43164 17.0049 8.65171 17.6 8.70875C17.6891 8.71637 17.7725 8.75603 17.8346 8.82038C17.8968 8.88473 17.9335 8.96941 17.938 9.05875L17.939 9.80675Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="listed">
                <ul className="space-y-2 text-lg" style={{ color: "#3A3A3A" }}>
                  <li>
                    <Link to="/about-us">About</Link>
                  </li>
                  <li>Blog</li>
                  <li>
                    <Link to="/FAQ">FAQs</Link>
                  </li>
                  <li>
                    <Link to="/T&C">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy"> Privacy policy</Link>
                  </li>
                  <li>
                    <Link to="/security">Security</Link>
                  </li>
                  {/* <li>
                  <Link to="/join-team">Jobs</Link>
                </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="hidden-lg">
            <div className="flex flex-col items-start justify-start pb-2 space-y-8">
              <div className="inline-flex items-center space-x-4">
                <img src={logo} className="w-8 md:w-10" alt="logo" />
                <img className="w-auto" src={cashlet} alt="cashlet" />
              </div>
              <div className="listed">
                <ul className="space-y-4 text-sm lg:text-lg ">
                  <li>
                    <Link to="/about-us">About</Link>
                  </li>
                  <li>Blog</li>
                  <li>
                    <Link to="/FAQ">FAQs</Link>
                  </li>
                  <li>
                    <Link to="/T&C">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy"> Privacy policy</Link>
                  </li>
                  <li>
                    <Link to="/security">Security</Link>
                  </li>
                  {/* <li>
                  <Link to="/join-team">Jobs</Link>
                </li> */}
                </ul>
              </div>
              <div className="separator"></div>
              <ul
                className="text-sm lg:text-lg "
                style={{ lineHeight: "26px" }}
              >
                <li>4th Floor, Laiboni Center</li>
                <li>Lenana Road, Kilimani</li>
                <li>Nairobi, Kenya </li>
                <li style={{ textDecoration: "none" }}>0112029738 </li>
                <li className="pt-4 underline">team@cashlet.co.ke</li>
              </ul>
              <div style={{ display: "flex", alignItems: "center" }}>
                <a
                  href="https://web.facebook.com/cashletapp/"
                  className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1_830)">
                      <path
                        d="M12 2.61914C6.477 2.61914 2 7.09614 2 12.6191C2 17.6101 5.657 21.7471 10.438 22.4981V15.5091H7.898V12.6191H10.438V10.4161C10.438 7.91014 11.93 6.52614 14.215 6.52614C15.309 6.52614 16.453 6.72114 16.453 6.72114V9.18114H15.193C13.95 9.18114 13.563 9.95214 13.563 10.7431V12.6191H16.336L15.893 15.5091H13.563V22.4981C18.343 21.7481 22 17.6091 22 12.6191C22 7.09614 17.523 2.61914 12 2.61914Z"
                        fill="#17191E"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_830">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0 0.619141)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/cashletapp/"
                  className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1_833)">
                      <path
                        d="M12 2.61914C14.717 2.61914 15.056 2.62914 16.122 2.67914C17.187 2.72914 17.912 2.89614 18.55 3.14414C19.21 3.39814 19.766 3.74214 20.322 4.29714C20.8305 4.79704 21.224 5.40173 21.475 6.06914C21.722 6.70614 21.89 7.43214 21.94 8.49714C21.987 9.56314 22 9.90214 22 12.6191C22 15.3361 21.99 15.6751 21.94 16.7411C21.89 17.8061 21.722 18.5311 21.475 19.1691C21.2247 19.8369 20.8311 20.4418 20.322 20.9411C19.822 21.4495 19.2173 21.8429 18.55 22.0941C17.913 22.3411 17.187 22.5091 16.122 22.5591C15.056 22.6061 14.717 22.6191 12 22.6191C9.283 22.6191 8.944 22.6091 7.878 22.5591C6.813 22.5091 6.088 22.3411 5.45 22.0941C4.78233 21.8436 4.17753 21.4501 3.678 20.9411C3.16941 20.4413 2.77593 19.8366 2.525 19.1691C2.277 18.5321 2.11 17.8061 2.06 16.7411C2.013 15.6751 2 15.3361 2 12.6191C2 9.90214 2.01 9.56314 2.06 8.49714C2.11 7.43114 2.277 6.70714 2.525 6.06914C2.77524 5.40132 3.1688 4.79646 3.678 4.29714C4.17767 3.78837 4.78243 3.39487 5.45 3.14414C6.088 2.89614 6.812 2.72914 7.878 2.67914C8.944 2.63214 9.283 2.61914 12 2.61914ZM12 7.61914C10.6739 7.61914 9.40215 8.14592 8.46447 9.08361C7.52678 10.0213 7 11.2931 7 12.6191C7 13.9452 7.52678 15.217 8.46447 16.1547C9.40215 17.0924 10.6739 17.6191 12 17.6191C13.3261 17.6191 14.5979 17.0924 15.5355 16.1547C16.4732 15.217 17 13.9452 17 12.6191C17 11.2931 16.4732 10.0213 15.5355 9.08361C14.5979 8.14592 13.3261 7.61914 12 7.61914ZM18.5 7.36914C18.5 7.03762 18.3683 6.71968 18.1339 6.48526C17.8995 6.25084 17.5815 6.11914 17.25 6.11914C16.9185 6.11914 16.6005 6.25084 16.3661 6.48526C16.1317 6.71968 16 7.03762 16 7.36914C16 7.70066 16.1317 8.0186 16.3661 8.25302C16.6005 8.48744 16.9185 8.61914 17.25 8.61914C17.5815 8.61914 17.8995 8.48744 18.1339 8.25302C18.3683 8.0186 18.5 7.70066 18.5 7.36914ZM12 9.61914C12.7956 9.61914 13.5587 9.93521 14.1213 10.4978C14.6839 11.0604 15 11.8235 15 12.6191C15 13.4148 14.6839 14.1779 14.1213 14.7405C13.5587 15.3031 12.7956 15.6191 12 15.6191C11.2044 15.6191 10.4413 15.3031 9.87868 14.7405C9.31607 14.1779 9 13.4148 9 12.6191C9 11.8235 9.31607 11.0604 9.87868 10.4978C10.4413 9.93521 11.2044 9.61914 12 9.61914Z"
                        fill="#17191E"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_833">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0 0.619141)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCX_gBYtp_3X--RL0TvQ0olg"
                  className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1_836)">
                      <path
                        d="M8.75439 12.493L12.0073 10.6196L8.75439 8.74609V12.493Z"
                        fill="black"
                      />
                      <path
                        d="M10 0.619141C4.478 0.619141 0 5.09714 0 10.6191C0 16.1411 4.478 20.6191 10 20.6191C15.522 20.6191 20 16.1411 20 10.6191C20 5.09714 15.522 0.619141 10 0.619141ZM16.2485 10.6294C16.2485 10.6294 16.2485 12.6574 15.9912 13.6353C15.847 14.1706 15.425 14.5927 14.8897 14.7367C13.9117 14.9941 10 14.9941 10 14.9941C10 14.9941 6.09848 14.9941 5.11032 14.7265C4.57504 14.5825 4.15298 14.1602 4.00879 13.625C3.75137 12.6574 3.75137 10.6191 3.75137 10.6191C3.75137 10.6191 3.75137 8.59125 4.00879 7.61331C4.15283 7.07803 4.58527 6.6456 5.11032 6.50156C6.08826 6.24414 10 6.24414 10 6.24414C10 6.24414 13.9117 6.24414 14.8897 6.51178C15.425 6.65582 15.847 7.07803 15.9912 7.61331C16.2589 8.59125 16.2485 10.6294 16.2485 10.6294Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_836">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0 0.619141)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href="https://twitter.com/cashletapp"
                  className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1_839)">
                      <path
                        d="M10.0009 20.619C15.5237 20.619 20.0008 16.1419 20.0008 10.6191C20.0008 5.09625 15.5237 0.619141 10.0009 0.619141C4.47809 0.619141 0.000976562 5.09625 0.000976562 10.6191C0.000976562 16.1419 4.47809 20.619 10.0009 20.619Z"
                        fill="black"
                      />
                      <path
                        d="M16.1257 7.80546C15.6971 7.99548 15.2362 8.124 14.7527 8.1814C15.2463 7.88567 15.6251 7.41774 15.8039 6.85926C15.3421 7.13325 14.8303 7.332 14.2861 7.43914C13.85 6.97477 13.2288 6.68457 12.5409 6.68457C11.2211 6.68457 10.1507 7.75501 10.1507 9.07483C10.1507 9.26218 10.1719 9.44454 10.2129 9.61959C8.22636 9.51994 6.46499 8.5684 5.28599 7.12184C5.08028 7.47479 4.96228 7.88567 4.96228 8.32365C4.96228 9.15273 5.38457 9.88466 6.02558 10.3132C5.63395 10.3009 5.26514 10.1934 4.94302 10.0139C4.94285 10.0241 4.94285 10.0342 4.94285 10.0442C4.94285 11.2023 5.76711 12.1683 6.86037 12.3878C6.66 12.4427 6.44841 12.4717 6.23076 12.4717C6.07639 12.4717 5.92683 12.4569 5.78101 12.4291C6.08512 13.3785 6.96768 14.0696 8.01387 14.089C7.19567 14.7302 6.16516 15.1122 5.04499 15.1122C4.85247 15.1122 4.66173 15.101 4.4751 15.0787C5.53235 15.7572 6.78906 16.1527 8.13883 16.1527C12.5354 16.1527 14.9397 12.5106 14.9397 9.35167C14.9397 9.2481 14.9374 9.14489 14.9328 9.04257C15.4002 8.70566 15.8053 8.28479 16.1257 7.80546Z"
                        fill="#F1F2F2"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_839">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0 0.619141)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href="https://www.tiktok.com/@cashletapp"
                  className="font-normal items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M12 2.09375C10.0222 2.09375 8.08879 2.68024 6.4443 3.77905C4.79981 4.87787 3.51809 6.43965 2.76121 8.26692C2.00433 10.0942 1.8063 12.1048 2.19215 14.0447C2.578 15.9845 3.53041 17.7663 4.92894 19.1648C6.32746 20.5633 8.10929 21.5158 10.0491 21.9016C11.9889 22.2875 13.9996 22.0894 15.8268 21.3325C17.6541 20.5757 19.2159 19.2939 20.3147 17.6495C21.4135 16.005 22 14.0716 22 12.0938C21.9974 9.4424 20.9429 6.9004 19.0681 5.02561C17.1934 3.15082 14.6514 2.0964 12 2.09375ZM17.939 9.80675V10.4528C17.939 10.5022 17.9291 10.5511 17.9099 10.5967C17.8907 10.6422 17.8625 10.6835 17.8271 10.718C17.7917 10.7525 17.7497 10.7795 17.7037 10.7975C17.6576 10.8155 17.6084 10.8241 17.559 10.8228C16.5032 10.7482 15.493 10.3626 14.656 9.71475V14.4427C14.6558 14.966 14.5513 15.484 14.3487 15.9665C14.1461 16.4489 13.8494 16.8862 13.476 17.2528C13.0995 17.6289 12.6517 17.9261 12.1589 18.127C11.6661 18.3279 11.1382 18.4285 10.606 18.4228C9.53587 18.4212 8.50876 18.0013 7.744 17.2528C7.2574 16.7622 6.9069 16.1533 6.727 15.4862C6.5471 14.819 6.544 14.1165 6.718 13.4478C6.877 12.8057 7.198 12.2157 7.651 11.7347C7.98883 11.3218 8.41468 10.9896 8.8974 10.7625C9.38012 10.5353 9.90751 10.4189 10.441 10.4218H11.261V12.1248C11.2614 12.1742 11.2512 12.2232 11.2311 12.2684C11.2111 12.3136 11.1816 12.354 11.1447 12.387C11.1078 12.4199 11.0643 12.4446 11.0171 12.4594C10.9699 12.4742 10.9201 12.4787 10.871 12.4727C10.3949 12.3297 9.88186 12.3772 9.44004 12.6051C8.99822 12.8329 8.66214 13.2235 8.50265 13.6943C8.34315 14.1651 8.37269 14.6795 8.58505 15.129C8.79742 15.5785 9.176 15.928 9.641 16.1038C9.911 16.2587 10.213 16.3498 10.523 16.3708C10.763 16.3808 11.003 16.3507 11.231 16.2787C11.6116 16.1503 11.9427 15.9064 12.1781 15.5808C12.4134 15.2553 12.5414 14.8644 12.544 14.4628V5.84775C12.544 5.75245 12.5818 5.66103 12.6491 5.59354C12.7164 5.52606 12.8077 5.48801 12.903 5.48775H14.318C14.4099 5.48786 14.4984 5.52315 14.5651 5.58637C14.6319 5.64959 14.6719 5.73595 14.677 5.82775C14.7286 6.26898 14.8687 6.69525 15.089 7.08102C15.3093 7.46678 15.6052 7.8041 15.959 8.07275C16.4371 8.43164 17.0049 8.65171 17.6 8.70875C17.6891 8.71637 17.7725 8.75603 17.8346 8.82038C17.8968 8.88473 17.9335 8.96941 17.938 9.05875L17.939 9.80675Z"
                      fill="black"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="separator my-4"></div>
          <div
            className="footer-help opacity-70 text-sm"
            style={{ lineHeight: "20px" }}
          >
            <div>
              Cashlet is the savings and investing product of Sycamore Capital
              Kenya Ltd, and was successfully exited from the Regulatory Sandbox
              of the Capital Markets Authority in 2024 and given the approval to
              roll out
            </div>
            <br />
            <div>
              Sycamore Capital Kenya Ltd is registered with the Companies
              Registry with registration number: PVT-EYUMZ7M. Our office is on
              4th Floor - Laiboni Center, Lenana Rd, Kilimani, Nairobi, Kenya.
            </div>
            <br />

            <div>
              Cashlet does not provide financial advice and individual investors
              should make their own decisions or seek independent advice. The
              value of investments can go up as well as down and you may receive
              back less than your original investment.
            </div>
          </div>
        </div>
      </footer>
    </>
  );
} 
